import { translate } from '@/domains/core/localization/translate';
export const fourAndMoreRatings = translate({
  "label": "4 stars and above"
});